import { Navigate, useSearchParams } from "react-router-dom";

/**
 * /enquiries/detail?id=ID used to be a separate details page. Enquiry details now live in the
 * popup on the Enquiries list, so old links (e.g. "From enquiry" on an event) open that popup.
 */
export default function EnquiryDetailRedirect() {
  const [searchParams] = useSearchParams();
  const id = Number(searchParams.get("id"));
  return <Navigate to={id > 0 ? `/enquiries?open=${id}` : "/enquiries"} replace />;
}
